import React, {useState} from 'react'
import Plot from 'react-plotly.js'
import {Select} from 'antd'

const {Option} = Select

const StreamgraphChart2 = () => {
  const [data, setData] = useState(generateRandomData(20))
  const [selectedVirus, setSelectedVirus] = useState('Influenza')
  // Sample data
  function generateRandomData(numWeeks: number): {
    x_data: string[]
    y_data1: number[]
    y_data2: number[]
    y_data3: number[]
    y_data4: number[]
  } {
    const x_data: string[] = []
    const y_data1: number[] = []
    const y_data2: number[] = []
    const y_data3: number[] = []
    const y_data4: number[] = []

    for (let i = 1; i <= numWeeks; i++) {
      x_data.push(`Week${i}`)
      y_data1.push(Math.floor(Math.random() * 10) + 1) // Random number between 1 and 10
      y_data2.push(Math.floor(Math.random() * 5)) // Random number between 0 and 4
      y_data3.push(Math.floor(Math.random() * 10) + 1) // Random number between 1 and 10
      y_data4.push(Math.floor(Math.random() * 10) + 1) // Random number between 1 and 10
    }

    return {x_data, y_data1, y_data2, y_data3, y_data4}
  }

  const trace3 = {
    x: data.x_data,
    y: data.y_data3,
    type: 'bar',
    marker: {color: '#DBDFE9'},
    name: 'Cases',
  }

  const trace4 = {
    x: data.x_data,
    y: data.y_data4,
    yaxis: 'y2',
    type: 'scatter',
    mode: 'lines',
    line: {color: '#203879'},
    name: 'DEATH   ',
  }

  const plotData = [trace3, trace4]

  const layout = {
    title: `Number of deaths in patients with a diagnosis of ${selectedVirus}`,
    barmode: 'stack',
    bargap: 0.2, // Adjust the gap between bars
    bargroupgap: 0.1, // Adjust the gap between bar groups
    autosize: true,

    xaxis: {
      title: 'Weeks',
      autorange: true,
      type: 'category',
    },
    yaxis: {
      title: '%',
      autorange: true,
    },
    yaxis2: {
      title: '%',
      showgrid: false,
      titlefont: {color: 'rgb(148, 103, 189)'},
      tickfont: {color: 'rgb(148, 103, 189)'},
      overlaying: 'y',
      side: 'right',
    },
    legend: {
      x: 0,
      y: -0.2, // Adjust the value to position the legend as per your requirement
      orientation: 'h', // 'h' for horizontal, 'v' for vertical
    },
  }

  // function handleDataChange(value) {
  //   if (value === 'Covid') {
  //     setData(generateRandomData(20)) // Change to your actual data
  //     setSelectedVirus('SARS-CoV2')
  //   } else if (value === 'Influenza') {
  //     setData(generateRandomData(20)) // Change to your actual data
  //     setSelectedVirus('Influenza')
  //   } else {
  //     setData(generateRandomData(20)) // Change to your actual data
  //     setSelectedVirus('RSV')
  //   }
  // }

  return (
    <>
      {/* <div className='row'>
        <label style={{width: '10%'}} className='col-1 mt-3 text-primary fw-medium fs-5'>
          Virus :
        </label>
        <div className='col-6'>
          <Select
            variant='borderless'
            className='border border-gray-500 border-3 rounded'
            style={{width: '70%'}}
            size='large'
            defaultValue='Influenza'
            onChange={handleDataChange}
          >
              <Option key={'Influenza'} value={'Influenza'}>
              Influenza
            </Option>
            <Option key={'RSV'} value={'RSV'}>
              RSV
            </Option>
          </Select>
        </div>
      </div> */}

      <Plot
        style={{width: '100%', height: '400px'}}
        data={plotData}
        layout={layout}
        config={{
          displaylogo: false,
          responsive: true,
        }}
      />
    </>
  )
}

export default StreamgraphChart2
